import AuthorisationCheck from 'components/wrappers/AuthorisationCheck/index';

import Dashboard from './Dashboard';

const withAuthorisation = AuthorisationCheck('DASHBOARD:VIEW');

export default withAuthorisation(Dashboard);
